import { useMemo } from "react";
import { useSystemView } from "@/app/hook/use-system-view";

export type SupervisorAccess = {
  isSupervisorMode: boolean;
  canMutate: boolean;
};

export function useSupervisorAccess(): SupervisorAccess {
  const { status, userData } = useSystemView();

  return useMemo(() => {
    const isSupervisorMode = status === "enabled" && Boolean(userData);
    return {
      isSupervisorMode,
      canMutate: !isSupervisorMode,
    };
  }, [status, userData]);
}
